var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"hojaDeVida",attrs:{"size":"lg","hide-footer":"","no-close-on-backdrop":"","title":"Hoja de vida"}},[(_vm.loader)?_c('Loading'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }